import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { FC } from "react";

interface Props {
    // Título principal y secundario
    title?: string;
    secondaryTitle?: string;

    // Subtítulo
    subtitle?: string;

    // Párrafo descriptivo
    description?: string;

    // Texto del botón
    buttonText?: string;
    onButtonClick?: () => void;

    // Imagen y estilos
    titleColor: string;
    imageSrc: string;
    backgroundColorImage: string;
}

const Banner: FC<Props> = ({
    title,
    secondaryTitle,
    subtitle,
    description,
    buttonText,
    onButtonClick,
    titleColor,
    imageSrc,
    backgroundColorImage,
}) => {
    return (
        <Grid
            container
            sx={{
                width: "100%",
                minHeight: "170px",
                borderRadius: 3,
                backgroundImage: backgroundColorImage,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                p: { xs: 2, md: 3 },
                display: "flex",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                position: "relative",
                gap: { xs: 4, md: 5 },
                mt: { xs: 1, md: 0 },
                flexWrap: "nowrap",
            }}
        >
            {/* Imagen */}
            <Grid item xs={10} sm={4} md={3}>
                <Box
                    component="img"
                    src={imageSrc}
                    alt="Imagen de cabecera"
                    sx={{
                        maxWidth: { xs: "150px", sm: "200px", md: "250px" },
                        height: "auto",
                        objectFit: "contain",
                        aspectRatio: 4 / 3,
                        width: "100%",
                        ml: 5,
                        
                        
                    }}
                />
            </Grid>

            {/* Textos y botón */}
            <Grid
                item
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.2,
                    alignItems: { xs: "center", md: "flex-start" },
                    textAlign: { xs: "center", md: "left" },
                    flex: 1,
                }}
            >
                {/* Título principal */}
                {title && (
                    <>
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            color={titleColor}
                            fontFamily="Montserrat"
                            textAlign={{ xs: "center", md: "left" }}
                            sx={{
                                fontSize: {
                                    xs: "1.2rem",
                                    sm: "1.4rem",
                                    md: "1.6rem",
                                    lg: "1.8rem",
                                },
                                textTransform: "uppercase",
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="h4"
                            fontWeight="600"
                            color={titleColor}
                            fontFamily="Montserrat"
                            textAlign={{ xs: "center", md: "left" }}
                            sx={{
                                fontSize: {
                                    xs: "20px",
                                    sm: "20px",
                                    md: "20px",
                                    lg: "20px",
                                },
                                textTransform: "uppercase",
                            }}
                        >
                            {secondaryTitle}
                        </Typography>
                        <Divider
                            sx={{
                                width: { xs: "50px", md: "60px" },
                                height: "4px",
                                backgroundColor: titleColor,
                                borderRadius: 2,
                            }}
                        />
                    </>
                )}

                {/* Subtítulo */}
                {subtitle && (
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontFamily: "Montserrat",
                            fontWeight: 700,
                            fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                            },
                            color: "rgba(0, 0, 0, 0.6)",
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}

                {/* Descripción */}
                {description && (
                    <Typography
                        variant="body1"
                        color="rgba(0, 0, 0, 0.6)"
                        fontSize={{
                            xs: "14px",
                            sm: "14px",
                            md: "14px",
                        }}
                        sx={{
                            fontWeight: 400,
                            fontFamily: "Montserrat",
                            textAlign: { xs: "center", md: "left" },
                            lineHeight: { xs: 1.3, md: 1.5 },
                            maxWidth: { xs: "100%", xl: "80%" },
                        }}
                    >
                        {description}
                    </Typography>
                )}

                {/* Botón alineado a la derecha del contenedor 
                {buttonText && (
                    <Box
                        sx={{
                            mt: 2,
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end", 
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={onButtonClick}
                            sx={{
                                borderRadius: 999,
                                px: 3,
                                py: 1,
                                textTransform: "none",
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                fontSize: "0.9rem",
                                backgroundColor: "#336B87",
                                "&:hover": {
                                    backgroundColor: "#285369",
                                },
                            }}
                        >
                            {buttonText}
                        </Button>
                    </Box>
                )}*/}
            </Grid>
        </Grid>
    );
};

export default Banner;
